import React from 'react';

interface WhiteButtonProps {
  onClick: () => void;
  label?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

const WhiteButton: React.FC<WhiteButtonProps> = ({
  onClick,
  label,
  icon,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`py-2 px-2 inline-flex items-center gap-x-1.5 text-xs rounded-lg
                       disabled:opacity-50 focus:outline-none focus:bg-gray-50 dark:bg-neutral-800 dark:border-neutral-700
                       dark:text-neutral-300 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700 relative
                       border border-slate-200 text-slate-800 hover:bg-cyan-100
                       disabled:pointer-events-none disabled:bg-zinc-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-neutral-600 ${className}`}>
      {icon}
      {label}
    </button>
  );
};

export default WhiteButton;
